import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-become-instructor-partner',
  templateUrl: './become-instructor-partner.component.html',
  styleUrls: ['./become-instructor-partner.component.scss']
})
export class BecomeInstructorPartnerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
